import MotorEventosOrdinariosService from "./motor-eventos-ordinarios-service"
import MotorParametrosService from "./motor-parametros-service"
import MotorDataAniversarioService from "./motor-data-aniversario-service"
import MotorService from "./motor-service"
import MotorRecompraProgramadaService from "./motor-recompra-programada-service"
import MotorConversibilidadeService from "./motor-conversibilidade-service"
import MotorPremioService from "./motor-premio-service"

export class MotorDuplicarEventosService {

    constructor() {
        this.motorService = new MotorService()
        this.parametrosService = new MotorParametrosService()
        this.dataAniversarioService = new MotorDataAniversarioService()
        this.premioService = new MotorPremioService()
        this.recompraProgramdaService = new MotorRecompraProgramadaService()
        this.conversibilidadeService = new MotorConversibilidadeService()
        this.eventosService = new MotorEventosOrdinariosService()
    }

    getValue = (res) => res?.status === 'fulfilled' ? res.value : null
    getBodyOrNull = (result) => result?.body ?? null

    async duplicaCadastroEventos(row, novoCetip, novaVersao, cadastroId, cadastroDestinoId) {
        const {Parametros, EventosOrdinarios, EventosExtraordinarios} = row

        // todo: falta adicionar extraordinarios
        console.log(`EventosExtraordinarios: ${EventosExtraordinarios}`)

        const parametrosRequest = this.parametrosRequest(Parametros, cadastroId)
        const eventosRequest = this.eventosRequest(EventosOrdinarios, cadastroId)

        const requests = [
            {
                key: "caracteristica",
                promise: this.motorService.getCadastro(cadastroDestinoId)
            },
            ...parametrosRequest,
            ...eventosRequest
        ]

        const results = await Promise.allSettled(
            requests.map(({promise}) => promise)
        )

        const resultsByKey = requests.reduce((acc, request, index) => {
            acc[request.key] = results[index]
            return acc
        }, {})

        const caracteristicaRes = resultsByKey.caracteristica
        const parametrosRes = resultsByKey.parametros
        const eventosOrdinariosRes = resultsByKey.eventosOrdinarios
        const dataAniversarioRes = resultsByKey.dataAniversario
        const premioRes = resultsByKey.premio
        const recompraProgramadaRes = resultsByKey.recompraProgramada
        const conversibilidadeRes = resultsByKey.conversibilidade

        const caracteristica = this.getValue(caracteristicaRes)
        const parametros = this.getValue(parametrosRes)
        const eventosOrdinarios = this.getValue(eventosOrdinariosRes)
        const dataAniversario = this.getValue(dataAniversarioRes)
        const premio = this.getValue(premioRes)
        const recompraProgramada = this.getValue(recompraProgramadaRes)
        const conversibilidade = this.getValue(conversibilidadeRes)

        return {
            'CETIP': novoCetip,
            'VersaoDocumento': novaVersao,
            'RendaFixaCaracteristicasID': cadastroDestinoId,
            'Caracteristica': this.getBodyOrNull(caracteristica),
            'Parametros': this.getBodyOrNull(parametros),
            'EventosOrdinarios': this.getBodyOrNull(eventosOrdinarios),
            'DataAniversario': this.getBodyOrNull(dataAniversario),
            'Premio': this.getBodyOrNull(premio),
            'RecompraProgramada': this.getBodyOrNull(recompraProgramada),
            'Conversibilidade': this.getBodyOrNull(conversibilidade)
        }
    }

    parametrosRequest(parametros, cadastroId) {
        const request = []
        if (parametros === null) return request
        const {Status} = parametros

        if (Status === "Em Andamento") {
            request.push({
                key: "parametros",
                promise: this.parametrosService.getCadastroTemporarioParametros(cadastroId)
            })
        }

        if (Status === "Em Produção") {
            request.push({
                key: "parametros",
                promise: this.parametrosService.getCadastroParametros(cadastroId)
            })
        }

        return request
    }

    eventosRequest(eventosOrdinarios, cadastroId) {
        const request = []
        if (eventosOrdinarios === null) return request
        const {Status} = eventosOrdinarios

        if (Status === "Em Andamento") {
            request.push(
                {
                    key: "eventosOrdinarios",
                    promise: this.eventosService.getTemporarioEventosOrdinarios(cadastroId)
                },
                {
                    key: "dataAniversario",
                    promise: this.dataAniversarioService.getTemporarioDataAniversario(cadastroId)
                },
                {
                    key: "premio",
                    promise: this.premioService.getTemporarioPremio(cadastroId)
                },
                {
                    key: "recompraProgramada",
                    promise: this.recompraProgramdaService.getTemporarioRecompraProgramada(cadastroId)
                },
                {
                    key: "conversibilidade",
                    promise: this.conversibilidadeService.getTemporarioConversibilidade(cadastroId)
                }
            )
        }

        if (Status === "Em Produção") {
            request.push(
                {
                    key: "eventosOrdinarios",
                    promise: this.eventosService.getEventosOrdinarios(cadastroId)
                },
                {
                    key: "dataAniversario",
                    promise: this.dataAniversarioService.getDataAniversario(cadastroId)
                },
                {
                    key: "premio",
                    promise: this.premioService.getPremio(cadastroId)
                },
                {
                    key: "recompraProgramada",
                    promise: this.recompraProgramdaService.getRecompraProgramada(cadastroId)
                },
                {
                    key: "conversibilidade",
                    promise: this.conversibilidadeService.getConversibilidade(cadastroId)
                }
            )
        }

        return request
    }
}